import { render } from "./RepoActionView.vue?vue&type=template&id=40701dcd&scoped=true&ts=true"
import script from "./RepoActionView.vue?vue&type=script&lang=ts"
export * from "./RepoActionView.vue?vue&type=script&lang=ts"

import "./RepoActionView.vue?vue&type=style&index=0&id=40701dcd&scoped=true&lang=css"
import "./RepoActionView.vue?vue&type=style&index=1&id=40701dcd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40701dcd"]])

export default __exports__